import { displayNumberWithComma } from "~/plugins/functions/display";

export interface IModelQuotaPeriodLimit {
  quota: string | number;
  overall: string | number;
}

export class ModelQuotaPeriodLimit {
  quota: string | number;
  overall: string | number;

  constructor(props = {} as IModelQuotaPeriodLimit) {
    props = props ?? {};
    this.quota = props.quota || 0;
    this.overall = displayNumberWithComma(props.overall || 0) ;
  }
}

export interface IModelQuotaLimits {
  perDay: IModelQuotaPeriodLimit;
  perMonth: IModelQuotaPeriodLimit;
}

export class ModelQuotaLimits  {
  perDay: ModelQuotaPeriodLimit;
  perMonth: ModelQuotaPeriodLimit;

  constructor(props = {} as IModelQuotaLimits) {
    props = props ?? {};
    this.perDay = new ModelQuotaPeriodLimit(props.perDay || {});
    this.perMonth = new ModelQuotaPeriodLimit(props.perMonth || {});
  }
}

export interface IModelQuotaLimitsByModel {
  perDay: IModelQuotaPeriodLimit;
  perMonth: IModelQuotaPeriodLimit;
}

export class ModelQuotaLimitsByModel {
  perDay: ModelQuotaPeriodLimit;
  perMonth: ModelQuotaPeriodLimit;

  constructor(props = {} as IModelQuotaLimitsByModel) {
    props = props ?? {};
    this.perDay = new ModelQuotaPeriodLimit(props.perDay || {});
    this.perMonth = new ModelQuotaPeriodLimit(props.perMonth || {});
  }
}

export interface IModelQuotaByModel {
  gpt_oss: IModelQuotaLimitsByModel;
  gemini: IModelQuotaLimitsByModel;
  claude: IModelQuotaLimitsByModel;
}

export class ModelQuotaByModel {
  gptOss: ModelQuotaLimitsByModel;
  gemini: ModelQuotaLimitsByModel;
  claude: ModelQuotaLimitsByModel;

  constructor(props = {} as IModelQuotaByModel) {
    props = props ?? {};
    this.gptOss = new ModelQuotaLimitsByModel(props.gpt_oss || {});
    this.gemini = new ModelQuotaLimitsByModel(props.gemini || {});
    this.claude = new ModelQuotaLimitsByModel(props.claude || {});
  }
}

export interface IModelQuotaSuperAdminListQueryParamsRequest {
  limit?: number;
  page?: number;
  count?: boolean;
  quotaDepartmentId?: string;
  parentId?: string;
  ignorePage?: boolean;
  orderBy?: string;
  orderType?: 'ASC' | 'DESC';
  searchQuery?: string;
}

